<template>
  <div id="cashierGoodsDetails">
    <div class="rc-title flex-between">
      <div>无码收银</div>
      <div class="back" @click="back">X</div>
    </div>
    <div class="content-wrap">
      <div>
        <div style="margin-top:20px">商品单价</div>
        <div class="buy">
          <input class="buyInput" v-model="goodsIfm.retailPrice"/>
        </div>
      </div>
      <div>
        <div style="margin-top:20px">购买数量</div>
        <div class="buy">
          <input
            class="buyInput"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
            v-model="buyNumber"
          />
        </div>
      </div>
      <div class="confirm">
        <el-button type="primary" @click="selectGoods">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: 1,
      goodsIfm: { retailPrice: 0, goodsName: "无码商品" },
      buyNumber: 1
    };
  },
  created() {},
  methods: {
    // buyInput(e) {
    //   console.log(e, this.goodsIfm.retailPrice, 'this.goodsIfm.retailPrice')
    //   // let reg = "/^[+]{0,1}(\d+)$/"
    //   if (!Number(this.goodsIfm.retailPrice)) {
    //     this.$message({
    //       type: "warning",
    //       message: "请输入正确数量"
    //     });
    //   }
    // },
    //选择商品 productId
    selectGoods() {
      if (this.buyNumber <= 0) {
        this.$message({
          type: "warning",
          message: "请输入正确数量"
        });
        return;
      } else if (this.goodsIfm.retailPrice <= 0 || !Number(this.goodsIfm.retailPrice)) {
        this.$message({
          type: "warning",
          message: "请输入正确单价"
        });
        return;
      }
      var arr = this.goodsIfm; //选择的商品
      var shoppingTrolley = this.$store.state.cartList;
      arr.productId = parseInt((Math.random() * 9 + 1) * Math.pow(10, 10), 10); //随机生成10位数id
      arr.retailPrice = Number(arr.retailPrice);
      arr.goodsNum = Number(this.buyNumber);
      shoppingTrolley.push(arr);
      this.$store.state.cartList = shoppingTrolley;
     if (this.$store.state.offers.type == 2) {
          this.$store.state.offers.type = 0;
          this.$store.state.offers.reducePrice = 0;
        } else if (this.$store.state.offers.type == 3) {
          this.$store.state.offers.type = 0;
           this.$store.state.offers.discountNumber = 0;
        }
      this.$store.commit("countTotalPrice");
      this.$store.commit("countCartListPrice");
      this.buyNumber = 1; //商品详情的进货数量
      this.$router.go(-1); //返回上一页
    },
    back() {
      this.$router.go(-1);
    },
    add() {
      this.$store.state.cartList.push({});
    }
  }
};
</script>
<style scoped>
.buy {
  position: relative;
}
.unit {
  position: absolute;
  top: 20px;
  left: 110px;
  color: #999999;
}
.confirm {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
#cashierGoodsDetails {
  height: 100%;
  width: 100%;
}
.buyInput {
  width: 50px;
  padding: 12px 41px;
  margin-top: 10px;
}
.product2 {
  padding: 12px 41px;
  /* background: rgba(30, 148, 234, 1); */
  border: 1px solid rgba(30, 148, 234, 1);
  border-radius: 2px;
  color: rgba(30, 148, 234, 1);
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
}
.product {
  padding: 12px 41px;
  background: rgba(30, 148, 234, 1);
  border: 1px solid rgba(16, 142, 233, 1);
  border-radius: 2px;
  color: #fff;
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
}
.borderBottom {
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
}
.goodsSprice {
  color: #f92323;
}
.goodsName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.goodsText {
  margin-left: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.goodsImg img {
  height: 100px;
  width: 100px;
}
.content-wrap {
  padding: 23px 26px;
  font-size: 14px;
}
.back {
  color: gray;
  font-size: 20px;
  cursor: pointer;
}
.rc-title {
  /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderNoBarcode.vue